import React, { useState } from "react";
import { Target, Edit2, Check, TrendingUp } from "lucide-react";
import Card from "../../../components/ui/Card";

const RevenueGoalWidget = ({ currentRevenue = 12500 }) => {
  const [goalName, setGoalName] = useState("New Studio Camera");
  const [goalAmount, setGoalAmount] = useState(45000);
  const [isEditing, setIsEditing] = useState(false);

  // Edit state holders
  const [editName, setEditName] = useState(goalName);
  const [editAmount, setEditAmount] = useState(goalAmount);

  const percentage = Math.min(100, Math.round((currentRevenue / goalAmount) * 100));

  const handleSave = () => {
    setGoalName(editName);
    setGoalAmount(Number(editAmount));
    setIsEditing(false);
  };

  return (
    <div className="bg-gradient-to-r from-emerald-600 to-teal-600 rounded-xl p-5 text-white shadow-md mb-6 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-white/10 rounded-full blur-2xl"></div>
      <div className="absolute bottom-0 left-0 -mb-4 -ml-4 w-20 h-20 bg-black/10 rounded-full blur-xl"></div>

      <div className="relative z-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex-1 w-full">
          <div className="flex items-center justify-between mb-2">
            <h3 className="flex items-center text-emerald-100 text-sm font-semibold uppercase tracking-wider">
              <Target size={16} className="mr-2" />
              Current Goal
            </h3>
            {!isEditing && (
              <button 
                onClick={() => setIsEditing(true)}
                className="text-emerald-100 hover:text-white transition-colors p-1 rounded hover:bg-white/10"
              >
                <Edit2 size={14} />
              </button>
            )}
          </div>

          {isEditing ? (
            <div className="flex flex-col sm:flex-row gap-2 mb-2 animate-fadeIn bg-white/10 p-3 rounded-lg backdrop-blur-sm">
                <input 
                    type="text" 
                    value={editName}
                    onChange={(e) => setEditName(e.target.value)}
                    className="bg-black/20 border border-white/20 rounded px-2 py-1 text-white placeholder-white/50 focus:outline-none focus:border-white text-sm flex-1"
                    placeholder="Goal Name"
                />
                <input 
                    type="number" 
                    value={editAmount}
                    onChange={(e) => setEditAmount(e.target.value)}
                    className="bg-black/20 border border-white/20 rounded px-2 py-1 text-white placeholder-white/50 focus:outline-none focus:border-white text-sm w-full sm:w-32"
                    placeholder="Amount"
                />
                <button 
                    onClick={handleSave}
                    className="bg-white text-emerald-600 px-3 py-1 rounded text-sm font-bold hover:bg-emerald-50"
                >
                    <Check size={16} />
                </button>
            </div>
          ) : (
             <div className="flex items-baseline gap-3 mb-2">
                <h2 className="text-2xl font-bold">{goalName}</h2>
                <div className="text-emerald-100 font-medium">
                    <span className="text-white font-bold">{currentRevenue.toLocaleString()}</span> 
                    <span className="mx-1">/</span> 
                    {goalAmount.toLocaleString()} ETB
                </div>
             </div>
          )}

          <div className="relative pt-1">
             <div className="flex mb-2 items-center justify-between text-xs">
                <div className="font-semibold px-2 py-0.5 rounded bg-white/20 text-white">
                    {percentage}% Funded
                </div>
                <div className="text-emerald-100 flex items-center">
                    <TrendingUp size={12} className="mr-1" />
                    Keep it up!
                </div>
             </div>
             <div className="overflow-hidden h-3 mb-1 text-xs flex rounded-full bg-black/20">
                <div
                  style={{ width: `${percentage}%` }}
                  className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-white transition-all duration-1000 ease-out relative"
                >
                    {/* Shimmer effect */}
                    <div className="absolute top-0 left-0 bottom-0 right-0 bg-gradient-to-r from-transparent via-white/30 to-transparent w-full -translate-x-full animate-shimmer"></div>
                </div>
             </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RevenueGoalWidget;
